<template>
  <div class="mx-12">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined
      ><v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <div>
      <h3 class="text-center mb-1"><b>Editar El Plan de Pagos</b></h3>
      <hr class="mb-4 mt-0" />
      <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>

      <v-row no-gutters>
        <v-col>
          <p class="mb-0">
            <b>Estudiante: </b>{{ estudiante.nombres }} {{ estudiante.primer_apellido }}
            {{ estudiante.segundo_apellido }}
          </p>
          <p class="mb-0"><b>Documento: </b>{{ estudiante.numero_documento }}</p>
          <p><b>Tel/cel: </b>{{ estudiante.telefono1 }}</p>
        </v-col>
        <v-col>
          <p class="mb-0"><b>Programa: </b>{{ programa.nombre_compuesto }}</p>
          <p class="mb-0 mt-0"><b>Inscripcion: </b>{{ inscripcion.id }}</p>
        </v-col>
      </v-row>
      <hr class="mb-4 mt-0" />

      <div class="table-responsive">
        <b>Detalle del plan de pagos actual:</b>
        <table class="table table-striped table-condensed table-hover">
          <thead style="background: #1F6E43">
            <tr class="white--text">
              <th>Cuota</th>
              <th style="min-width:200px">Concepto</th>
              <th width="150px">Monto</th>
              <th>Saldo</th>
              <th>Descuento</th>
              <th>Fecha de Pago</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(d, ind) in inscripcion.plan_pagos"
              :key="ind"
              :style="'background:' + getbackground(d.concepto_pago_id)"
            >
              <td :title="'id: ' + d.id">No. {{ d.numero_cuota }}</td>
              <td>{{ d.concepto_pago }}</td>
              <td :title="'d.mod_monto: ' + d.mod_monto">
                <v-text-field
                  prefix="Bs.  "
                  color="#16365c"
                  :disabled="d.mod_monto"
                  type="number"
                  v-model.number="d.monto"
                  @input="changecuota(d, true)"
                  dense
                  hide-details
                ></v-text-field>
              </td>
              <td>{{ d.saldo }} bs.</td>
              <td>{{ d.descuento }} bs.</td>
              <td>
                <v-text-field
                  type="date"
                  :disabled="d.mod_fecha"
                  v-model="d.fecha_pago"
                  @blur="changecuota(d, true)"
                  dense
                  hide-details
                ></v-text-field>
              </td>
              <td :title="'del_item: ' + d.del_item">
                <v-tooltip bottom v-if="d.del_item">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" @click="deletecuota(d)" class="mx-1 red darken-2" dark tile small>
                      <v-icon dark small> mdi-minus-thick </v-icon>
                    </v-btn>
                  </template>
                  <span>Quitar concepto </span>
                </v-tooltip>

                <v-tooltip bottom v-if="d.add_item">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      xdisabled="desactivarItem(d)"
                      @click="createcuota(d)"
                      class="mx-1 green darken-2"
                      dark
                      tile
                      small
                    >
                      <v-icon dark small> mdi-plus-thick </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar concepto </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      v-if="!desactivarItem(d, true)"
                      @click="opendiasRetraso(d)"
                      class="mx-1 orange darken-2"
                      dark
                      tile
                      small
                    >
                      <v-icon dark small> mdi-calendar-clock-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Dias retraso </span>
                </v-tooltip>
              </td>
            </tr>

            <tr style="background: #1F6E43;" class="white--text">
              <td></td>
              <td></td>
              <td>{{ sumatoria(inscripcion.plan_pagos, 'monto') }} bs.</td>
              <td>{{ sumatoria(inscripcion.plan_pagos, 'saldo') }} bs.</td>
              <td>{{ sumatoria(inscripcion.plan_pagos, 'descuento') }} bs.</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-btn @click="openmodaladdconcepto()" class="mx-0 green darken-3" dark tile>
        <v-icon dark left small> mdi-note-plus </v-icon> Agregar concepto
      </v-btn>
      <div><Conceptos ref="xconceptos" v-on:onselectconceptonew="onselectconceptonew" /></div>
      <hr class="mt-0" />
      <div class="xcard">
        <b class="mb-2">Resumen de pagos por conceptos:</b>
        <div><hr class="mt-0 mb-3" /></div>
        <div v-html="resumen()"></div>
      </div>
    </div>

    <div class="text-center">
      <p class="text-danger" style="font-size:1.3em">{{ msg }}</p>
      <div>
        <div style="display: inline-block;" v-show="loadingediting" class="loader"></div>
      </div>
      <button
        class="btn btn-azul mb-14"
        :disabled="!valido || loadingediting || conceptos.length == 0 || issuccess"
        @click="editar()"
      >
        <span class="glyphicon glyphicon-download-alt white--text"></span> Guardar edicion
      </button>
    </div>

    <Dias ref="diasretraso" v-on:successdias="successdias" />
  </div>
</template>

<style lang="css">
  tbody > tr > td {
    padding-bottom: 0 !important;
  }
  .v-application--is-ltr .v-text-field__prefix {
    font-size: 0.7em;
  }
  .vv-input input {
    color: #16365c !important;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  import Conceptos from '@/components/AEditarPlanConceptos';
  import Dias from '@/components/ADiasRetraso';
import { validarPlanPagosOnEditar } from '../views/utils/plan_cobros';
  export default {
    data() {
      return {
        xidnew: 1000000,
        msg: '',
        loadingediting: false,
        loading: false,
        valido: true,
        conceptos: [],
        issuccess: false,
        estudiante: {},
        programa: {},
        inscripcion: {
          plan_pagos: [],
        },
        colores: [
          '#F5F9FF',
          'rgba(108,13,131,0.05)',
          'rgba(13,131,37,0.05)',
          '#rgba(131,13,74,0.05)',
          '#F5FCFF',
          '#F5FCFF',
        ],
        cuotasquitadas: [],
        lastwatch: 0,
        firstchange: false,
      };
    },
    watch: {
      'inscripcion.plan_pagos': {
        deep: true,
        handler() {},
      },
    },
    components: { Conceptos, Dias },
    methods: {
      desactivarItem(item) {
        //window.console.log('ITEM:::', item);
        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        date.setHours(0);
        date.setMinutes(0);

        let date2 = new Date(item.fecha_pago);
        date2.setHours(date2.getHours() + 4 + 1);

        let menor = date2.getTime() < date.getTime();

        // window.console.log('date2>>>\n', date2, '\n', date, '\n\n--', item.fecha_pago, menor);
        if (item.xbloqueado || menor) return true;
        return false;
      },
      handlerPagos() {
        let vue = this;

        this.inscripcion.plan_pagos.forEach((x) => {
          let old = vue.desactivarItem(x);
          x.mod_retraso = old;
          x.mod_monto = old;
          x.mod_fecha = old;
          x.add_item = old;
          x.del_item = false;
          x.add_item = false;
          if (old) {
            x.del_item = false;
            x.add_item = false;

            let filtrados = vue.inscripcion.plan_pagos.filter((p) => p.concepto_pago_id == x.concepto_pago_id);
            let ultimo = filtrados[filtrados.length - 1];
            if (ultimo && ultimo.id == x.id) {
              ultimo.add_item = true;
            }
          } else {
            let filtrados = vue.inscripcion.plan_pagos.filter((p) => p.concepto_pago_id == x.concepto_pago_id);
            let ultimo = filtrados[filtrados.length - 1];
            window.console.log('--', x, ultimo);
            if (ultimo && ultimo.id == x.id) {
              ultimo.del_item = true;
              ultimo.add_item = true;
            } else {
              ultimo.del_item = false;
              ultimo.add_item = false;
            }
          }
        });
      },
      sumatoria(planes, field) {
        if (!planes) return 0;
        let suma = 0;
        planes.forEach((e) => {
          suma += parseInt(e[field]);
        });
        return suma;
      },
      getbackground(conceptoid) {
        let index = conceptoid;
        if (conceptoid > this.colores.length) {
          index = conceptoid % this.colores.length;
          //window.console.log(index, conceptoid, this.colores.length);
        }
        return this.colores[index];
      },
      openmodaladdconcepto() {
        this.$refs.xconceptos.open(this.conceptos, this.inscripcion.plan_pagos);
      },
      onselectconceptonew(nuevo) {
        this.createcuota(nuevo);
        this.ordenar(this.inscripcion);
      },
      /*showboton(plan, isadd) {
        //window.console.log('ultimo', plan);
        let filtrados = this.inscripcion.plan_pagos.filter(
          (x) => x.concepto_pago_id == plan.concepto_pago_id /*&& x.saldo > 0*,
        );
        //DESCOMENTAR PARA PERMITIR ELIMINAR CUOTAS
        //EN CASO DE NRO CUOTAS DUPLICADAS
        /*if (!isadd) {
          if (plan.saldo > 0) return true;
        }*
        let ultimo = filtrados[filtrados.length - 1];
        if (ultimo) {
          // window.console.log('ultimo', ultimo.id, plan.id, filtrados);
          if (ultimo.id != plan.id) return false;
        }

        if (isadd) {
          if (!plan.monto) return false;
          if (filtrados.length == 0) return true;
        } else {
          if (plan.xbloqueado) return false;
          if (filtrados.length == 0) return true;
        }
        return true;
      },*/
      ordenar(data3) {
        // window.console.log('<<<>>>',data3.plan_pagos);
        data3.plan_pagos.forEach(x=>{
          if (!x.monto) x.monto = x.total; 
          if (!x.numero_cuota) x.numero_cuota = x.nro_cuota;
          x.numero_cuota = parseInt(x.numero_cuota);
        })
        data3.plan_pagos.sort((a, b) => {
          window.console.log('>>>>>> ',a,b);
          if (!a.monto) a.monto = a.total;
          if (!b.monto) b.monto = b.total;
          if (!a.numero_cuota) a.numero_cuota = a.nro_cuota;
          if (!b.numero_cuota) b.numero_cuota = b.nro_cuota;
          a.numero_cuota = parseInt(a.numero_cuota);
          b.numero_cuota = parseInt(b.numero_cuota);
          //CODIGO ORIGINAL
          /* if (!a.xnuevo && !b.xnuevo) {
            if (a.saldo == 0 || a.saldo != a.monto) a.xbloqueado = true;
            else a.xbloqueado = false;
            if (b.saldo == 0 || b.saldo != b.monto) b.xbloqueado = true;
            else b.xbloqueado = false;
          } */
          // CORRECCION EDITAR MONTO, PERO NO MAS AL SALDO PENDIENTE
          if (!a.xnuevo && !b.xnuevo) {
            if (a.saldo == 0 || (a.saldo + a.descuento != a.monto && a.saldo == 0)) a.xbloqueado = true;
            else a.xbloqueado = false;
            if (b.saldo == 0 || (b.saldo + b.descuento != b.monto && b.saldo == 0)) b.xbloqueado = true;
            else b.xbloqueado = false;
          }
          return a.concepto_pago_id - b.concepto_pago_id || a.numero_cuota - b.numero_cuota;
        });
      },
      changecuota(plan, set_actual) {
        this.msg = '';
        this.valido = true;
        //plan.saldo = plan.monto; // esto porque?
        let unidad = this.$store.state.CARGO.sede.unidad_negocio
        if (!plan.monto && (unidad == 1 || unidad == 5 || unidad == 10)) {
          this.msg = `Falta el monto en concepto: '${plan.concepto_pago}' cuota: ${plan.numero_cuota}.`;
          this.valido = false;
        } /* else if (plan.monto < plan.saldo) {
          this.msg = `No puede bajar menos de: '${plan.saldo}', en concepto: '${plan.concepto_pago}' cuota: ${plan.numero_cuota}.`;
          this.valido = false;
        }  */ else if (
          !plan.fecha_pago
        ) {
          this.msg = `Falta la fecha de pago en concepto: '${plan.concepto_pago}' cuota: ${plan.numero_cuota}.`;
          this.valido = false;
        }
        /*/*/

        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        date.setHours(23);
        date.setMinutes(59);

        let date2 = new Date(plan.fecha_pago);
        date2.setHours(date2.getHours() + 4);

        let menor = date2.getTime() < date.getTime();
        if (plan.fecha_pago && menor && set_actual) {
          let hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          const [year, month, day] = hoy.split('-');
          let txt = `${year}-${month}-${day}`;
          this.valido = false;
          this.$root.$notify.show(`Fechas pasadas no estan permitidas.`, { color: 'red' });
          setTimeout(() => {
            plan.fecha_pago = txt;
            //window.console.log('date2>>>>>><<<\n', date2, '\n', date, '\n\n--', plan.fecha_pago, menor);
          }, 2300);
        }
      },
      validarantesdeenviar() {
        const vue = this;
        let set_actual = false;
        this.inscripcion.plan_pagos.forEach((x) => {
          vue.changecuota(x, set_actual);
        });
        if (this.inscripcion.plan_pagos.length == 0) {
          this.msg = 'Debe tener al menos una cuota en el plan de pagos.';
          this.valido = false;
        }
      },
      resumen() {
        let conceptos = [];
        this.inscripcion.plan_pagos.forEach((x) => {
          let existe = conceptos.find((c) => c.concepto_pago_id == x.concepto_pago_id);
          if (existe) {
            existe.xmonto += Number(x.monto);
            existe.xsaldo += Number(x.saldo);
          } else {
            let xc = {
              concepto_pago_id: x.concepto_pago_id,
              xmonto: Number(x.monto),
              xsaldo: Number(x.saldo),
              xconcepto: x.concepto_pago,
            };
            conceptos.push(xc);
          }
        });
        let html = '';
        conceptos.forEach((x) => {
          html += `<p class="mb-0 mt-0"> <b> ${x.xconcepto} </b> total: ${x.xmonto} bs. Saldo: ${x.xsaldo} bs. </p>`;
        });
        return html;
      },
      deletecuota(plan) {
        this.msg = '';
        this.valido = true;
        /*const vue = this;
        let quitadas = this.inscripcion.plan_pagos.filter((x) => x.id == plan.id);
        quitadas.forEach(x => {
          let existe = vue.cuotasquitadas.find( c => c.id == x.id && x.concepto_pago_id == plan.concepto_pago_id);
          if( !existe ) vue.cuotasquitadas.push(plan);
        })*/
        let existe = this.cuotasquitadas.find(
          (c) => c.numero_cuota == plan.numero_cuota && c.concepto_pago_id == plan.concepto_pago_id,
        );
        if (!existe) this.cuotasquitadas.push(plan);
        this.inscripcion.plan_pagos = this.inscripcion.plan_pagos.filter((x) => x.id != plan.id);
        this.handlerPagos();

        /* let vue = this;
        setTimeout(() => {
          let filtrados = vue.inscripcion.plan_pagos.filter((p) => p.concepto_pago_id == plan.concepto_pago_id);
          let ultimo = filtrados[filtrados.length - 1];
          window.console.log(';;;', filtrados, ultimo);
          if (ultimo && ultimo.id == plan.id)  ultimo.del_item = true;
          else ultimo.del_item = false;
        }, 1200); */
      },
      createcuota(plan) {
        let nuevo = window.Object.assign({}, plan);
        if (!nuevo.concepto) nuevo.concepto = 'nuevo';
        //window.console.log(plan);
        let h = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        h.setDate(h.getDate() + 1);
        // h.setHours(h.getHours() + 12);

        let hoy = h.toISOString().substr(0, 10);
        const [year, month, day] = hoy.split('-');
        let txt = `${year}-${month}-${day}`;
        nuevo.numero_cuota += 1;
        //nuevo.id += this.xidnew;
        delete nuevo.id;
        nuevo.xnuevo = true;
        nuevo.saldo = 0;
        nuevo.monto = 0;
        nuevo.fecha_pago = txt;
        nuevo.fecha_pago = '';
        nuevo.xbloqueado = false;
        nuevo.mod_monto = false;
        nuevo.mod_fecha = false;
        nuevo.del_item = true;
        nuevo.add_item = true;
        this.xidnew += 1;
        let existe = this.cuotasquitadas.find(
          (c) => c.numero_cuota == nuevo.numero_cuota && c.concepto_pago_id == nuevo.concepto_pago_id,
        );
        if (existe) nuevo.id = existe.id;
        let filtrados = this.inscripcion.plan_pagos.filter((x) => x.concepto_pago_id == plan.concepto_pago_id);
        let ultimo = filtrados[filtrados.length - 1];
        let indicefornew = -1;
        if (ultimo) {
          this.inscripcion.plan_pagos.forEach((x, i) => {
            if (x.id == ultimo.id) {
              indicefornew = i;
              nuevo.numero_cuota = ultimo.numero_cuota + 1;
            }
          });
        } else {
          nuevo.numero_cuota = 1;
          indicefornew = this.inscripcion.plan_pagos.length;
        }
        this.inscripcion.plan_pagos.splice(indicefornew + 1, 0, nuevo);
        this.changecuota(nuevo, true);
      },
      getinscripcionx(idpersona, idprograma, idinscripcion) {
        this.inscripcion.id = idinscripcion;
        let unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        this.loading = true;
        this.msg = '';
        const vue = this;
        const url1 = `${process.env.VUE_APP_API_REST}/esam/persona/id/${idpersona}`;
        const url2 = `${process.env.VUE_APP_API_REST}/esam/programa/id/${idprograma}`;
        const url3 = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion/id/${idinscripcion}`;
        const url4 = `${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`;
        const url5 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
        const promise1 = xaxios.get(url1);
        const promise2 = xaxios.get(url2);
        const promise3 = xaxios.get(url3);
        const promise4 = xaxios.post(url4, { unidad_negocio_id: unidad_negocio_id });
        const promise5 = xaxios.get(url5);
        Promise.all([promise1, promise2, promise3, promise4, promise5])
          .then(function(values) {
            let data1 = values[0].data;
            let data2 = values[1].data;
            let data3 = values[2].data;
            let data4 = values[3].data;
            let data5 = values[4].data;
            data5.data.map((x) => {
              x.mod_retraso = true;
              x.mod_monto = true;
              x.mod_fecha = true;
              x.add_item = true;
              x.del_item = true;
            });
            data3.plan_pagos = data5.data;
            window.console.log('=================', data3, data5);
            data4 = data4.filter((x) => !x.opcional);
            vue.estudiante = data1.persona;
            vue.programa = data2;
            vue.conceptos = data4;
            vue.ordenar(data3);
            vue.inscripcion = data3;
            vue.handlerPagos();
            vue.loading = false;
            //window.console.log(JSON.stringify(data3.plan_pagos, null, 4));
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
          });
      },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async editar() {
        this.validarantesdeenviar();
        if (!this.valido) return; 
        //window.console.log(JSON.stringify(this.inscripcion, null, 4));
        const vue = this;
        let xins = {};
        let planes = [];
        this.inscripcion.plan_pagos.forEach((x) => {
          let plan = {};
          //window.console.log(x);
          if (x.saldo == 0 || x.descuento != 0) plan.id = x.id;
          else if (x.id) plan.id = x.id;
          //if (!x.xnuevo) plan.id = x.id;
          //else plan.id = 0;
          plan.numero_cuota = x.numero_cuota;
          plan.concepto_pago_id = x.concepto_pago_id;
          plan.monto = Number(x.monto);
          //plan.saldo = x.saldo;
          plan.fecha_pago = x.fecha_pago;
          planes.push(plan);
        });
        xins.inscripcion_id = this.inscripcion.id;
        xins.plan_pagos = planes;

        // window.console.log(JSON.stringify(this.inscripcion.plan_pagos, null, 4));

        const errores = validarPlanPagosOnEditar(this.inscripcion.plan_pagos);
        if(errores.length > 0){ 
          const p = errores[0]
          const t = `En ${p.nombre} entre la cuota ${p.cuotaAnterior} y ${p.cuotaSiguiente} no puede haber mas de 31 dias de diferencia [${p.diferenciaDias}]`;
          this.msg = t
          return;
        }

        //window.console.log(JSON.stringify(xins, null, 4)); 
        // window.console.log(JSON.stringify(xins, null, 4));
        var message = {
          title: 'Solicitamos su aprobacion para esta accion:',
          body: '<br> <b>NOTA:</b> Esta accion guarda el plan de pagos editado',
        };
        var options = {
          html: true,
          okText: 'Guardar plan',
          cancelText: 'Cancelar',
          reverse: true,
          type: 'hard',
          verification: 'guardar',
          verificationHelp: 'Escriba "[+:verification]" para proceder.',
          loader: true,
        };
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            vue.loadingediting = true;
            vue.guardarplaneditado(xins, dialog);
          })
          .catch(function() {});
      },
      async guardarplaneditado(ins, dialog) {
        const vue = this;
        const iduser = this.$store.state.DATA_USER.id;
        if(iduser==-43){
          await this.sleep(3000); 
          this.$root.$notify.show(`No access`, {color:'black',x: 'right',});
          dialog.close();
          return;
        }
        //window.console.log(ins);
        let url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/plan-pago`;
        xaxios
          .put(url, ins)
          .then((res) => {
            window.console.log(res.data);
            if (typeof res.data.data == 'string') vue.msg = res.data.data;
            vue.loadingediting = false;
            vue.issuccess = true;
            dialog.close();
            //vue.getdefault();
          })
          .catch((error) => {
            window.console.log(JSON.stringify(ins, null, 4));
            try {
              vue.msg = error.response.data.data;
            } catch (e) {
              window.console.error(e);
            }
            if (error.response.data.error) vue.msg = error.response.data.error;
            window.console.error(error);
            vue.loadingediting = false;
            dialog.close();
          });
      },
      getdefault() {
        this.issuccess = false;
        let idper = this.$route.params.idpersona;
        let idpro = this.$route.params.idprograma;
        let idins = this.$route.params.idinscripcion;
        this.getinscripcionx(idper, idpro, idins);
      },
      opendiasRetraso(d) {
        let idins = this.$route.params.idinscripcion;
        let data = {
          inscripcion_id: idins,
          dias_retraso: 0,
          cuota_id: d.id,
        };
        this.$refs.diasretraso.openmodal(data);
      },
      successdias() {
        this.getdefault();
      },
    },
    mounted() {
      this.getdefault();
    },
  };
</script>
